import * as types from "./types";

const initialState = {
  list: [],
  meta: {
    currentPage: 1,
    count: 0,
    pages: 1,
  },
  totals: {
    totalDeductions: 0,
    totalRewards: 0,
    totalNetPay: 0,
  },
  stats: {
    paidCount: 0,
    pendingCount: 0,
  },
};

const payroll = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_EVENT_PAYROLLS_REQUEST:
      return {
        ...state,
        list: [],
        meta: initialState.meta,
      };
    case types.GET_EVENT_PAYROLLS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
        totals: action.payload.totals,
      };
    case types.GET_EVENT_PAYROLL_STATS_RESPONSE:
      return {
        ...state,
        stats: action.payload,
      };
    default:
      return state;
  }
};

export default payroll;
